import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { TefProductCodeCreateValidationSchema } from '../../schemas/tefConfigurations/tefProductCode.schema'

interface UseCreateTefProductProps {
  provider?: string;
  establishmentId?: string;
  onSuccess: (response: AxiosResponse) => void;
  onError: (error: ErrorResponse) => void;
}

export const useCreateTefProductCode = ({ provider, establishmentId, onSuccess, onError }: UseCreateTefProductProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createTefProductCode'],
    mutationFn: async (form: TefProductCodeCreateValidationSchema) => {
      const payload = {
        tef_product_code: {
          code: form.code,
          product_id: form.product_id.value,
          provider,
          company_id: establishmentId,
        }
      }

      return privateAxios.post('/establishment/tef_product_codes', payload);
    },
    onSuccess,
    onError,
  });
}
